import apiClient from '../utils/axios-config';
import { BlogArticle, BlogComment } from '../types/blog';
import { logger } from '../utils/logger';

export interface PendingItems {
  articles: BlogArticle[];
  comments: BlogComment[];
}

class ModerationService {
  async getPendingItems(): Promise<PendingItems> {
    try {
      const response = await apiClient.get('/admin/moderation/pending');
      return response.data;
    } catch (error) {
      logger.apiError('fetching pending items', error);
      throw error;
    }
  }

  async approveArticle(articleId: string): Promise<void> {
    try {
      await apiClient.post(`/admin/moderation/approve/${articleId}`);
    } catch (error) {
      logger.apiError('approving article', error);
      throw error;
    }
  }

  async rejectArticle(articleId: string, reason: string): Promise<void> {
    try {
      await apiClient.post(`/admin/moderation/reject/${articleId}`, { reason });
    } catch (error) {
      logger.apiError('rejecting article', error);
      throw error;
    }
  }

  async deleteComment(commentId: string): Promise<void> {
    try {
      await apiClient.delete(`/admin/moderation/${commentId}`);
    } catch (error) {
      logger.apiError('deleting comment via moderation', error);
      throw error;
    }
  }
}

export default new ModerationService();
